import { Routes } from '@angular/router';

export const AMENITIES_ROUTES: Routes = [
  {
    path: 'amenities',
    loadComponent: () =>
      import('./amenities-list/amenities-list.component')
        .then(m => m.AmenitiesListComponent),
  },
  {
    path: 'amenities/create',
    loadComponent: () =>
      import('./amenities-form/amenities-form.component')
        .then(m => m.AmenitiesFormComponent),
  },
  {
    path: 'amenities/edit/:id',
    loadComponent: () =>
      import('./amenities-form/amenities-form.component')
        .then(m => m.AmenitiesFormComponent),
  },
];
